<template>
  <div>
    <FocusLayout :title="inviterEntityTitle" subtitle="" v-if="inviterEntityTitle">
      <template #subtitle></template>
      <v-container>
        <SecondaryTitle>{{ inviterEntityTitle }} kutse aksepteerimine</SecondaryTitle>

        <div v-if="!$store.state.auth">
          Palun registreeru või logi sisse enda Bookus.live kontoga, et saaksid hakata Bookus
          keskkonnas
          {{ inviterEntityTitle }} broneeringuid haldama.
          <div class="mt-3">Ole mureta, see võtab vaid hetke!</div>
          <LoginOrRegister />
        </div>
        <div v-else>
          <v-btn color="success" large block :loading="loading" @click="acceptInvitation">
            Kutse kinnitamiseks kliki siia
          </v-btn>
          <v-alert type="error" class="mt-3" v-if="errorMessage">{{ errorMessage }}</v-alert>
        </div>
        <!-- <RegisterForm hide-title :login-link="false"></RegisterForm> -->
        <!-- <LoginForm hide-title :register-link="false"></LoginForm> -->
      </v-container>
    </FocusLayout>
    <FocusLayout v-else>
      <div class="h-100">
        <SecondaryTitle>Not found</SecondaryTitle>
        <v-container>
          {{
            $t(
              "Invitation not found. Please ask the administrator of company to send you new invitation.",
            )
          }}
        </v-container>
      </div>
    </FocusLayout>
  </div>
</template>

<script>
import SecondaryTitle from "@c/MainTitle/SecondaryTitle";
import LoginForm from "@c/Auth/LoginForm";
import RegisterForm from "@c/Auth/RegisterForm";
import LoginOrRegister from "@c/Auth/LoginOrRegister";
import FocusLayout from "@/landing/layout/FocusLayout/FocusLayout";
import AppLayout from "@/landing/layout/AppLayout";
import injectables from "@/_shared/lib/meta/injectables";

export default {
  components: {
    AppLayout,
    FocusLayout,
    LoginOrRegister,
    RegisterForm,
    LoginForm,
    SecondaryTitle,
  },

  data() {
    return {
      loading: false,
      errorMessage: null,
    };
  },

  computed: {
    inviterEntityTitle() {
      return this._.get(injectables, ["invitation", "entity_title"], null);
    },
  },

  methods: {
    async acceptInvitation() {
      this.loading = true;
      try {
        const response = await this.axios.post("/accept-invitation");
        window.location.replace(response.data.redirect);
      } catch (e) {
        this.errorMessage = e.response.data.message;
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
